import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "reactstrap";
import { IPauseChatProps, PAUSE_CATEGORIES } from "./~types/PauseChatProps";
import useOnClickOutside from "src/app/shared/hooks/useOnClickOutside";
import "./PauseChatDialog.css";

const PauseChatDialog = (props: IPauseChatProps) => {
    const { t } = useTranslation();
    const [selectedCategory, setSelectedCategory] = useState<PAUSE_CATEGORIES>(
        PAUSE_CATEGORIES.PAUSE_WITHOUT_NOTIFICATION
    );
    const [isOpened, setIsOpened] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const handlePauseChatButtonClick = () => {
        setIsOpened(!isOpened);
        if (props.selectedChat) {
            if (!props.selectedChat.onPause) {
                props.pauseChat(props.selectedChat.chatId, selectedCategory);
            } else {
                props.unpauseChat(props.selectedChat.chatId);
            }
        }
    };

    const handleDropdownKeyUp = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Escape") {
            setIsOpened(false);
        }
    };

    const handleOpenDropdown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter") {
            setIsOpened(true);
        }
    };

    const handlePauseChatButtonKeyUp = (
        e: React.KeyboardEvent<HTMLButtonElement>
    ) => {
        if (e.key === "Enter") {
            handlePauseChatButtonClick();
        }
    };

    useOnClickOutside([dropdownRef], (event: MouseEvent) => {
        if (isOpened && !dropdownRef?.current?.contains(event.target as Node)) {
            setIsOpened(false);
        }
    });

    return (
        <div>
            <div
                className={"pause-chat-dialog__toggle"}
                data-testid="pause-toggle"
                tabIndex={0}
                onClick={() => setIsOpened(!isOpened)}
                onKeyUp={handleOpenDropdown}
            >
                <span>
                    {t(
                        props.selectedChat.onPause
                            ? "chat.unpause"
                            : "chat.pause"
                    )}
                </span>
            </div>
            {isOpened && (
                <div
                    ref={dropdownRef}
                    className="pause-chat-dialog__menu"
                    data-testid="pause-dialog"
                    onKeyUp={handleDropdownKeyUp}
                >
                    {t(
                        props.selectedChat.onPause
                            ? "chat.removePauseHeader"
                            : "chat.setPauseHeader"
                    )}
                    <hr />

                    {!props.selectedChat.onPause && (
                        <Input
                            className="pause-chat-dialog__select"
                            data-testid="pause-category"
                            type="select"
                            value={selectedCategory}
                            tabIndex={0}
                            autoFocus
                            onChange={(e) =>
                                setSelectedCategory(
                                    e.currentTarget.value as PAUSE_CATEGORIES
                                )
                            }
                        >
                            <option
                                value={
                                    PAUSE_CATEGORIES.PAUSE_WITHOUT_NOTIFICATION
                                }
                            >
                                {t("chat.pauseWithoutNotifacation")}
                            </option>
                            <option
                                value={PAUSE_CATEGORIES.PAUSE_WITH_NOTIFICATION}
                            >
                                {t("chat.pauseWithNotifacation")}
                            </option>
                        </Input>
                    )}
                    <div className={"pause-chat-dialog__footer"}>
                        <hr />
                        <Button
                            className="pause-chat-dialog__action-btn"
                            data-testid="pause-submit"
                            onClick={handlePauseChatButtonClick}
                            onKeyUp={handlePauseChatButtonKeyUp}
                        >
                            {t(
                                props.selectedChat.onPause
                                    ? "chat.removePause"
                                    : "chat.setPause"
                            )}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PauseChatDialog;
